import { z } from "zod"
import { EventKind } from "./event-kind"
import { eventPayloads } from "./event-registry"

export const commentDisplaySchema = z.object({
    kind: z.literal("comment"),
    text: z.string(),
    replyCount: z.number(),
    parentAuthorId: z.string().nullable(),
})

export const activityDisplaySchema = commentDisplaySchema

export type ActivityDisplay = z.infer<typeof activityDisplaySchema>
export type CommentDisplay = z.infer<typeof commentDisplaySchema>

const timelineEventColumns = {
    id: z.uuid(),
    project_id: z.uuid().nullable(),
    subject_type: z.string().nullable(),
    created_by: z.guid(),
    created_at: z.coerce.date(),
    display: activityDisplaySchema.optional(),
}

const member = <K extends EventKind>(kind: K) =>
    z.object({ ...timelineEventColumns, kind: z.literal(kind), data: eventPayloads[kind] })

const asTuple = <T>(members: T[]) => members as [T, ...T[]]

export const activityTimelineEventSchema = z.discriminatedUnion(
    "kind",
    asTuple(Object.values(EventKind).map((kind) => member(kind)))
)

export type ActivityTimelineEvent = z.infer<typeof activityTimelineEventSchema>
